var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "salon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.883,
    height: 37.178,
    viewBox: "0 0 78.883 37.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 78.883,
    height: 37.178,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M50.772,28.409H72.256a6.626,6.626,0,0,0,6-3.82l-.15-.158a5.361,5.361,0,0,0-3.847-1.5H56.6V21.917H74.262a6.373,6.373,0,0,1,4.384,1.622,6.617,6.617,0,0,0,.237-1.757v-3.22H50.772Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M17.676,2.025A14.107,14.107,0,1,0,31.783,16.131,14.106,14.106,0,0,0,17.676,2.025m-1.8,24.849A10.894,10.894,0,0,1,6.786,16.131v-.073h4.038l.448,4.083a2.709,2.709,0,0,0,2.692,2.413h1.915v4.319ZM13.258,10.708a2.709,2.709,0,0,0-2.536,1.755H7.42a10.894,10.894,0,0,1,20.513,0h-3.3a2.709,2.709,0,0,0-2.536-1.755Zm6.216,16.166h0V22.554h1.915a2.709,2.709,0,0,0,2.692-2.413l.448-4.083h4.038v.073a10.894,10.894,0,0,1-9.093,10.743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M78.5,12.845l0,0A25.837,25.837,0,0,0,61.239,6.228H30.744l-.023-.062A9.327,9.327,0,0,0,21.945,0h-8.8A9.327,9.327,0,0,0,4.364,6.166l-.022.062L2.724,10.972a25.812,25.812,0,0,0-2.649,2.15L0,13.192v8.589a6.627,6.627,0,0,0,6.627,6.628H8.294a15.457,15.457,0,1,1,24.56-15.217H46.268v9.727H32.615V20.1a15.5,15.5,0,0,1-5.557,8.312h5.557l.762,6.969a2.019,2.019,0,0,0,2.007,1.8H43.5a2.019,2.019,0,0,0,2.007-1.8l.761-6.969h3.491V13.192h1.013v4.357H78.884V13.7a1.146,1.146,0,0,0-.379-.851M41.758,25.695a1.673,1.673,0,0,1,.894.259l-2.318,2.318a1.681,1.681,0,0,1,1.424-2.577m-4.258.043a1.682,1.682,0,0,1,0,3.279Zm-.748,0v3.279a1.681,1.681,0,0,1,0-3.279m0,9.091a1.681,1.681,0,0,1,0-3.279Zm.748,0V31.55a1.682,1.682,0,0,1,0,3.279m2.575-1.639a1.681,1.681,0,0,1,2.577-1.424l-2.318,2.318a1.673,1.673,0,0,1-.259-.894m1.683,1.682a1.679,1.679,0,0,1-.9-.259l2.318-2.318a1.681,1.681,0,0,1-1.423,2.577m1.682-4.231h-8v-.715h8ZM41.758,29.06a1.679,1.679,0,0,1-.9-.259l2.318-2.318a1.681,1.681,0,0,1-1.423,2.577M38.176,11.191h-5.56V10.66h5.56Zm0-.993h-5.56V9.6h5.56Zm0-1.055h-5.56V8.612h5.56Zm8.092,2.048h-5.56V10.66h5.56Zm0-.993h-5.56V9.6h5.56Zm0-1.055h-5.56V8.612h5.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 10.89,
    height: 8.315,
    transform: "translate(33.997 13.898)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalon);
export default __webpack_public_path__ + "static/media/salon.2600e202caef496f693d99317ae1f263.svg";
export { ForwardRef as ReactComponent };